import axiosInstance from 'api/axiosConfig'
import { ENDPOINTS } from 'api/endpoints'
import handleApiError from 'api/utils/handleApiError'

const useWizardService = () => {
  const loadRegisterPropertyStep = async (): Promise<any> => {
    try {
      const response = await axiosInstance.get(
        ENDPOINTS.WIZARD.REGISTER_PROPERTY_STEPS
      )
  
      if (!response.data) {
        throw new Error()
      }
  
      return response.data
    } catch (err) {
      handleApiError('Failed to fetch register property steps', err)
    }
  }
  
  const loadRegisterPropertyQuickSteps = async (): Promise<any> => {
    try {
      const response = await axiosInstance.get(
        ENDPOINTS.WIZARD.REGISTER_PROPERTY_QUICK_STEPS
      )
  
      if (!response.data) {
        throw new Error()
      }
  
      return response.data
    } catch (err) {
      handleApiError('Failed to fetch quick register property steps', err)
    }
  }

  const loadAuthRegisterPropertyQuickSteps = async (): Promise<any> => {
    try {
      const response = await axiosInstance.get(
        ENDPOINTS.WIZARD.AUTH_REGISTER_PROPERTY_QUICK_STEPS
      )
  
      if (!response.data) {
        throw new Error()
      }
  
      return response.data
    } catch (err) {
      handleApiError('Failed to fetch quick register property steps', err)
    }
  }

  return {
    loadRegisterPropertyStep,
    loadRegisterPropertyQuickSteps,
    loadAuthRegisterPropertyQuickSteps,
  }
}

export default useWizardService
